(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ca-school-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ca-school-filters')) {
  class CaSchoolFilters extends HTMLElement {
    connectedCallback() {
      this.updateSelection = this.updateSelection || this.markSelection.bind(this);
      document.addEventListener('on:facet-filters:updated', this.updateSelection);
      window.addEventListener('popstate', this.updateSelection);
      window.addEventListener('pageshow', this.updateSelection);
      this.markSelection();
    }

    disconnectedCallback() {
      document.removeEventListener('on:facet-filters:updated', this.updateSelection);
      window.removeEventListener('popstate', this.updateSelection);
      window.removeEventListener('pageshow', this.updateSelection);
    }

    markSelection() {
      const params = new URLSearchParams(window.location.search);
      const levels = params.getAll(this.dataset.filterKey);
      this.querySelectorAll('a').forEach((link) => {
        const all = link.hasAttribute('data-school-all');
        const active = all ? levels.length === 0 : levels.includes(link.dataset.schoolLevel);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        const url = new URL(link.href);
        if (!all && params.get('sort_by')) url.searchParams.set('sort_by', params.get('sort_by'));
        else url.searchParams.delete('sort_by');
        for (const key of ['preview_theme_id', '_fd']) {
          if (params.has(key)) url.searchParams.set(key, params.get(key));
        }
        link.href = url.pathname + url.search;
      });
    }
  }
  customElements.define('ca-school-filters', CaSchoolFilters);
}
  } catch(e) { console.error(e); }
})();

})();
